export const shopNamespace = 'shop';
export const defaultShopNamespace = shopNamespace + '.default';
export const selectedShopNamespace = shopNamespace + '.selected';
